import React from "react";
import { Link, useNavigate } from "react-router-dom";
import {logout} from '../store/authSlice'
import "./header.css";
import {useDispatch} from 'react-redux'
const Header = () => {
  const pages = ["Dashboard", "Projects", "Logout"];
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const handleClick = (item) => {
    if (item !== "Logout") {
      navigate(`/${item.toLowerCase()}`);
    }else{
        dispatch(logout())
        navigate('/login')
    }
  };

  return (
    <div>
      <div className="desktop">
        {pages.map((item, index) => (
          <span
            onClick={() => handleClick(item)}
            key={index}
            className="desk_link"
          >
            {item}
          </span>
        ))}
      </div>
    </div>
  );
};

export default Header;
